import apiRequest from "./apiClient";
import { createCategoryQuestion as createCategoryQuestionApi } from "./assessmentApi";
import {
  DEFAULT_AGE_OPTION_ROWS,
  optionRowsToPayload,
} from "../utils/assessmentFormat";

export {
  formatOptionImpacts,
  parseOptionImpacts,
  DEFAULT_AGE_OPTION_ROWS,
  optionRowsFromQuestion,
  optionRowsToPayload,
} from "../utils/assessmentFormat";

export async function fetchQuestionsByDevice(deviceId) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}/questions/all`);
  return body.data;
}

export async function fetchDeviceQuestionOverrides(deviceId) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}/questions/overrides`);
  return body.data;
}

export async function createQuestion(deviceId, payload) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}/questions`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateQuestion(questionId, payload) {
  const body = await apiRequest(`/api/v1/devices/questions/${questionId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function deleteQuestion(questionId) {
  await apiRequest(`/api/v1/devices/questions/${questionId}`, { method: "DELETE" });
}

export async function reactivateQuestion(questionId) {
  const body = await apiRequest(`/api/v1/devices/questions/${questionId}`, {
    method: "PUT",
    body: JSON.stringify({ isActive: true }),
  });
  return body.data;
}

export async function createCategoryQuestion(categoryId, payload) {
  return createCategoryQuestionApi(categoryId, payload);
}

export async function updateDeviceQuestionOverride(deviceId, templateQuestionId, payload) {
  const body = await apiRequest(
    `/api/v1/devices/${deviceId}/questions/template/${templateQuestionId}/override`,
    { method: "PUT", body: JSON.stringify(payload) }
  );
  return body.data;
}

export async function resetDeviceQuestionOverride(deviceId, templateQuestionId) {
  await apiRequest(
    `/api/v1/devices/${deviceId}/questions/template/${templateQuestionId}/override`,
    { method: "DELETE" }
  );
}

export const AGE_QUESTION_TEMPLATE = {
  question: "How old is your device?",
  type: "SINGLE_CHOICE",
  category: "age",
  ...optionRowsToPayload(DEFAULT_AGE_OPTION_ROWS),
  priceImpact: 0,
  displayOrder: 1,
  isRequired: true,
};

export const QUESTION_GROUP_PRESETS = [
  { value: "age", label: "Device age", hint: "Stable stored values with friendly display labels" },
  { value: "battery", label: "Battery health" },
  { value: "screen", label: "Screen condition" },
  { value: "warranty", label: "Warranty" },
  { value: "general", label: "General" },
];
